/* eslint-disable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector, createSelector } from 'reselect';

import ggOrder, { OrderComponentSummary } from 'ggApp/modules/order';
import ggAuth from 'ggApp/modules/auth';
import ggRouter from 'ggApp/modules/router';
import ggAddress, {
    AddressForm_Edit as EditAddressForm,
    withCountriesList,
    ADDRESS_TYPE,
} from 'ggApp/modules/address';
import {
    LayoutComponent_Grid_Col as Col,
    LayoutComponent_Grid_Row as Row,
    LayoutComponent_Container,
    LayoutComponent_Checkout_Title,
    LayoutComponent_Checkout_ContentWrap,
} from 'ggApp/modules/layout';
import { CheckoutBackToCartLink } from 'ggApp/modules/checkout/components';

const EditAddressFormWithCountries = withCountriesList(EditAddressForm);

@connect(
    createStructuredSelector({
        user: ggAuth.selectors.user,
        order: ggOrder.selectors.orderActive,
        editingAddress: createSelector(
            ggAddress.selectors.addressList,
            ggRouter.selectors.params,
            (al, p) => al.find((a) => a.id === Number(p.addressId)) || {},
        ),
    }),
    (dispatch) => ({
        routerActions: bindActionCreators(ggRouter.actions, dispatch),
        addressActions: bindActionCreators(ggAddress.actions, dispatch),
        authActions: bindActionCreators(ggAuth.actions, dispatch),
    }),
)
export default class CheckoutEditAddress extends Component {
    componentWillMount() {
        const { routerActions } = this.props;
        const { editingAddress } = this.props;

        if (!editingAddress) {
            routerActions.transitionTo('/checkout');
        }
    }

    render() {
        const { addressActions } = this.props;
        const { order, editingAddress } = this.props;

        return (
            !!editingAddress.id && (
                <section>
                    <LayoutComponent_Checkout_Title tk="CHECKOUT_ADDRESS_TITLE" />
                    <LayoutComponent_Container>
                        <LayoutComponent_Checkout_ContentWrap>
                            <Row cols={[1, 1]}>
                                <Col desktop={40}>
                                    <OrderComponentSummary
                                        order={order}
                                        desktopColumnItem
                                    />
                                    <CheckoutBackToCartLink />
                                </Col>
                                <Col desktop={60}>
                                    <EditAddressFormWithCountries
                                        addressType={ADDRESS_TYPE.SHIPPING}
                                        edit={addressActions.edit}
                                        initialValues={{
                                            country: editingAddress.country,
                                            streetName: editingAddress.street,
                                            houseNumber: editingAddress.house,
                                            additional:
                                                editingAddress.additionalInfo,
                                            city: editingAddress.city,
                                            postCode: editingAddress.postcode,
                                        }}
                                    />
                                </Col>
                            </Row>
                        </LayoutComponent_Checkout_ContentWrap>
                    </LayoutComponent_Container>
                </section>
            )
        );
    }
}
